import React, { Component } from "react";
import Table from "../component/Table";
import API from "../../apiService";
import ModalAddRoleAccess from "./modalAddUser";

export default class RoleAccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      refAccess: [],
      isLoading: true,
      modalShow: false,
      user: JSON.parse(localStorage.getItem("userData")),
      roleAccessData: null,
      search: "",
      searched : [],
      userPcare:[]
    };
  }

  componentDidMount() {
    this.getRoleAccess();
    this.getAccess();
  }

  getAccess = async () => {
    const res = await API.get("config/access/read");
    if (res.code === 200) {
      this.setState({
        refAccess: res.data,
      });
    }
  };

  getRoleAccess = async () => {
    const res = await API.get("config/role_access/read");
    if (res.code === 200) {
      this.setState({
        datas: res.data,
      });
    }
  };

  create_button(datas) {
    return (
      <div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() =>
            this.setState({ roleAccessData: datas }, () =>
              this.setState({ modalShow: true })
            )
          }
        >
          edit
        </button>
      </div>
    );
  }

  create_accesses(data) {
    return data.ref_access.map((v, k) => (
        <button key={`b-${k}`} className={'btn btn-sm btn-secondary mb-1'}>{v.access.name}</button>
    ))
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="card">
              <Table
                headers={[
                  "No",
                  "Role",
                  "Access",
                  "Aksi",
                ]}
                data={this.state.datas}
                columnMapper={(datas, key) => [
                  datas.name,
                  this.create_accesses(datas),
                  this.create_button(datas),
                ]}
                pagination={true}
              />
            </div>
          </div>
        </div>
        <ModalAddRoleAccess
          refreshdata={this.getRoleAccess}
          roleaccessdata={this.state.roleAccessData}
          refaccessdata={this.state.refAccess}
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
        />
      </div>
    );
  }
}
